import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Label = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M16.813 4.419A.997.997 0 0016 4H3a1 1 0 00-.813 1.581L6.771 12l-4.585 6.419A1 1 0 003 20h13a.997.997 0 00.813-.419l5-7a.997.997 0 000-1.162l-5-7zM15.485 18H4.943l3.87-5.419a.997.997 0 000-1.162L4.943 6h10.542l4.286 6-4.286 6z",
    key: "k0"
  }));
});
Label.displayName = 'Label';
export var LabelDimensions = {
  height: 24,
  width: 24
};